export enum PositionSideEnum {
	LONG = 'long',
	SHORT = 'short',
}
